"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Integration = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Suggestion = require("./Suggestion");

var _styles = require("./styles");

var _molecules = require("../../molecules");

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Integration = ({
  position,
  onClickBack,
  suggestions = [],
  inputProps,
  integrationSearchResultsView,
  onClickAddSuggestion
}) => {
  return /*#__PURE__*/_react.default.createElement(_styles.IntegrationRailContainerStyle, {
    position: position,
    "data-testid": "integration-view"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_molecules.NavHeader, {
    showCloseIcon: false,
    onClickIcon: onClickBack,
    iconName: "LeftArrow",
    label: "Back",
    iconSize: 21
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "integration-content-container"
  }, /*#__PURE__*/_react.default.createElement("label", null, "Add integration"), /*#__PURE__*/_react.default.createElement(_atoms.Input, {
    className: "search-local",
    icon: "Search",
    inputProps: { ...inputProps
    },
    kind: "md",
    label: ""
  }), suggestions.length && /*#__PURE__*/_react.default.createElement("label", {
    className: "margin-top"
  }, "Suggested for you"), suggestions.map((item, index) => /*#__PURE__*/_react.default.createElement(_Suggestion.Suggestion, _extends({}, item, {
    key: index,
    onClickAdd: onClickAddSuggestion
  }))), /*#__PURE__*/_react.default.isValidElement(integrationSearchResultsView) && integrationSearchResultsView));
};

exports.Integration = Integration;
Integration.defaultProps = {
  suggestions: [],
  inputProps: {
    boxed: false
  }
};
Integration.propTypes = {
  onClickBack: _propTypes.default.func,
  position: _propTypes.default.string,
  suggestions: _propTypes.default.array,

  /** Integration search input props*/
  inputProps: _propTypes.default.object,
  integrationSearchResultsView: _propTypes.default.node,
  onClickAddSuggestion: _propTypes.default.func
};